import CookieBanner from 'react-cookie-banner';
import React, { Component } from 'react';


const styles = {
    banner: {
        minHeight: '57px',
        height: 'auto',
        background: 'rgba(0, 0, 0, 0.8)',
        backgroundSize: '30px 30px',
        backgroundColor: '',
        fontSize: '15px',
        fontWeight: 600,
        position: 'fixed',
        bottom: '0px'
    },
    button: {
        border: '1px solid white',
        borderRadius: 4,
        width: 66,
        height: 32,
        lineHeight: '32px',
        background: 'transparent',
        color: 'white',
        fontSize: '14px',
        fontWeight: 600,
        opacity: 1,
        right: 20,
        marginTop: -18
    },
    message: {
        display: 'block',
        padding: '20px 97px 13px 20px',
        lineHeight: 1.3,
        textAlign: 'left',
        color: 'white'
    },
    link: {
        textDecoration: 'none',
        fontWeight: 'bold',
        color: 'rgb(102, 204, 255)'
    }
};

export default class FuckTheCookieLaw extends Component {


    render() {

        return (
            <div>
                <CookieBanner
                    styles={styles}
                    message="Diese Webseite verwendet Cookies. Wenn Sie diese Webseite nutzen, akzeptieren Sie die Verwendung von Cookies. "
                    onAccept={() => {}}
                    dismissOnScroll={false}
                    link={{
                        msg: 'Mehr erfahren.',
                        url: '/Datenschutzrichtlinie'
                    }}
                    buttonMessage='OK'
                    cookie='user-has-accepted-cookies'
                    />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/FuckTheCookieLaw.js